// Auto-generated normalizer for table: Estudiante
export function estudianteNormalize(row) {
  return {
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    avatarUrl: row.avatarUrl ?? row.AvatarUrl ?? row['AvatarUrl'] ?? '',
    nickname: row.nickname ?? row.Nickname ?? row['Nickname'] ?? '',
    modenas: row.modenas ?? row.Modenas ?? row['Modenas'] ?? 0,
    monedas: row.monedas ?? row.Monedas ?? row['Monedas'] ?? (row.modenas ?? row.Modenas ?? row['Modenas'] ?? 0),
    monedasGanadas: row.monedasGanadas ?? row.MonedasGanadas ?? row['MonedasGanadas'] ?? 0,
    monedasAcumuladas: row.monedasAcumuladas ?? row.MonedasAcumuladas ?? row['MonedasAcumuladas'] ?? (row.monedasGanadas ?? row.MonedasGanadas ?? row['MonedasGanadas'] ?? 0),
    monedasGastadas: row.monedasGastadas ?? row.MonedasGastadas ?? row['MonedasGastadas'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    notificacionesCursos: row.notificacionesCursos ?? row.NotificacionesCursos ?? row['NotificacionesCursos'] ?? false,
  };
}
